import { CurrencyAddress } from '@root/entities/currency/model'
import { Network } from '@root/entities/network/model'
import { PairAddress } from '@root/entities/pair'

import type { UserHiddenTokensListData } from '@blade/trade-api-client'
import type { CurrencyModel, CurrencyRef } from '@root/entities/currency/model'

export interface BlacklistCurrencyMeta {
  ref: CurrencyRef.Ref
  pairAddress?: PairAddress
  hiddenAt: Date
  currency: CurrencyModel | undefined
}

type Dto = UserHiddenTokensListData[number]
export const fromDto = (
  dto: Dto,
  currency: CurrencyModel | undefined,
): BlacklistCurrencyMeta => {
  return {
    pairAddress: dto.poolAddress ? PairAddress(dto.poolAddress) : undefined,
    hiddenAt: new Date(dto.hiddenAt),
    currency: currency,
    ref: {
      address: CurrencyAddress(dto.tokenAddress),
      network: Network.fromDto(dto.network),
    },
  }
}
